<template>
    <component
        :is="'VuePerfectScrollbar'"
        ref="filterScroll"
        class="filters_scroll_area"
        :settings="settings"
        :key="$vs.rtl"
    >
        <div
            id="filter-div-loading"
            class="vs-con-loading__container todo__filters-container"
        >
            <div class="px-6 py-4">
                <div class="flex cursor-pointer" @click="clearFilters()">
                    <feather-icon
                        icon="LayersIcon"
                        svgClasses="h-6 w-6"
                    ></feather-icon>
                    <span class="text-lg ml-3">{{ $t("show_all") }}</span>
                </div>
            </div>
            <vs-divider class="mb-0 mt-0" />
            <div class="px-6 py-4">
                <h5 class="mb-3">{{ $t("work_schedule") }}</h5>
                <multiselect
                    v-model="filter.schedule"
                    :options="schedules"
                    :searchable="false"
                    :selectedLabel="$t('selected')"
                    :close-on-select="true"
                    label="text"
                    :placeholder="$t('choose_option')"
                    :show-labels="false"
                    @input="getFiltered()"
                >
                </multiselect>
            </div>
            <!-- <vs-divider class="mb-0 mt-0" />
            <div class="px-6 py-4">
                <h5 class="mb-3">{{ $t("required_education") }}</h5>
                <vs-input
                    :placeholder="$t('input_for_search')"
                    class="w-full"
                    v-model="filter.required_education"
                    @change="getFiltered()"
                />
            </div> -->
            <vs-divider class="mb-0 mt-0" />
            <div class="px-6 py-4">
                <h5 class="mb-3">{{ $t("job") }}</h5>
                <vs-input
                    :placeholder="$t('input_for_search')"
                    class="w-full"
                    v-model="filter.job"
                    @change="getFiltered()"
                />
            </div>
            <div class="px-6 py-3 lg:hidden">
                <vs-button @click="sidebarToggle()" class="w-full">{{$t('apply')}}</vs-button>
            </div>
        </div>
    </component>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
    props: {
        // itemHandler: {
        //     type: Function,
        //     default: () => {}
        // }
        sidebarToggle: {
            type: Function,
            required: true
        },
        schedules: {
            type: Array
        }
    },
    data() {
        return {
            filter: {
                schedule: {
                    key: "0",
                    text: this.$t("full_time"),
                    uid: ""
                },
                required_education: "",
                job: "",
            },
            //schedules: [],
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.6,
            },
        };
    },
    methods: {
        ...mapActions({
            getVacanciesFiltered: "employment/getVacanciesFiltered",
            getSchedules: "employment/getSchedules",
        }),
        async clearFilters() {
            this.filter.schedule = {
                key: "",
            };
            this.filter.required_education = "";
            this.filter.job = "";
            let obj = {
                schedule: this.filter.schedule.key,
                required_education: this.filter.required_education,
                job: this.filter.job,
            };
            this.$vs.loading({
                container: "#filter-div-loading",
                scale: 0.6,
            });
            await this.getVacanciesFiltered(obj);
            //await this.setEducation();
            this.$vs.loading.close("#filter-div-loading > .con-vs-loading");
        },
        setElementSchedule(vacancie) {
            for(var i = 0; i < this.schedules.length; i++){
                if(this.schedules[i].uid === vacancie.schedule){
                    vacancie.schedule = this.schedules[i].name;
                    break;
                }
            }
        },
        async setEducation(){
            for(var i = 0; i < this.vacancies.length; i++){
                this.setElementSchedule(this.vacancies[i]);
                let eduProgram;
                await this.getEducationProgram(this.vacancies[i].required_education).then(function(res){
                    eduProgram = res.name;
                }, function(err){});
                this.vacancies[i].required_education_name = eduProgram;
            }
        },
        async getFiltered() {
            this.$vs.loading({
                container: "#filter-div-loading",
                scale: 0.6,
            });
            let schedule_uid = null;
            try{
                schedule_uid = this.schedules[this.filter.schedule.key].uid
            }catch{}
            let obj = {
                schedule: schedule_uid === null ? "" : schedule_uid,
                //schedule: allSchedules[this.filter.schedule.key].uid,
                //required_education: this.filter.required_education,
                required_education: "",
                job: this.filter.job,
            };
            await this.getVacanciesFiltered(obj);
            //await this.setEducation();
            this.$vs.loading.close("#filter-div-loading > .con-vs-loading");
        },
        async init() {
            this.$vs.loading({
                container: "#div-with-loading",
                scale: 0.6,
            });

            //await this.getSchedules();

            // let schedules = [];
            // await this.getSchedules().then(function(res){
            //     for(var i = 0; i < res.length; i++){
            //         res[i].key = i.toString();
            //         res[i].text = res[i].name;
            //     }
            //     //console.log(res);
            //     schedules = res;

            // }, function(err){});


            // this.schedules = schedules;
            //this.filter.schedule = this.schedules[0];


            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        },
    },
    components: {
        VuePerfectScrollbar,
    },

    mounted() {
        this.init();
    },
};
</script>
<style lang="scss">
.filter_select {
    .multiselect__placeholder {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 180px;
    }
}
.todo__filters-container {
    .multiselect__single {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
.vs-sidebar--items{
    section{
        height: 100%;
        .vs-con-loading__container{
            height: 100%;
        }
    }
}
</style>
